<template>
    <div></div>
</template>

<script>
import L from 'leaflet';
import { has_value } from "@/utils/app-util";
export default {
  props: {
    item: Object,
    unit: String,
    placeholder: {
      type: String,
      default: ""
    },
    title: String,
    position: {
      type: String,
      default: "bottomleft"
    }
  },
  mounted() {
    const { unit, title, placeholder, position } = this
    this.mapObject = L.control({
      position: position
    })
    this.mapObject.onAdd = function(map) {
      this._div = L.DomUtil.create("div", "custominfo") // create a div with a class "info"
      this.update({ name: "", value: 0, unit, placeholder, title })
      return this._div
    }
    this.mapObject.update = function({
      name,
      value,
      extraValues = undefined,
      unit,
      title,
      placeholder
    }) {
      if (name.length > 0) {
        this._div.innerHTML = (has_value(value))?`<h4> ${title} </h4>
                    <b> ${name} </b><br />總人數: ${value} ${unit}`:
                    `<h4> ${title} </h4>
                    <b> ${name} </b>`
        if (extraValues) {
          let tempmetric = undefined;
          for (const x of extraValues) {
            const temptype = x.metric.split(',')[0];
            const templight = x.metric.split(',')[1];
            if(temptype === tempmetric){
                if(templight === '藍'){
                    this._div.innerHTML =
                        (has_value(x.value))?this._div.innerHTML + `, ${templight} ${x.value}/${value}`:this._div.innerHTML + `, ${templight} 無資料`;
                }else{
                    this._div.innerHTML =
                        (has_value(x.value))?this._div.innerHTML + `, ${templight} ${x.value}`:this._div.innerHTML + `, ${templight} 無資料`;
                }
                
            }
            else{
                this._div.innerHTML =
                    (has_value(x.value))?this._div.innerHTML + `<br /> ${temptype}: ${templight} ${x.value}`:this._div.innerHTML + `<br /> ${temptype}: ${templight} 無資料`;
                tempmetric = temptype
            }
            
          }
        }
      } else {
        this._div.innerHTML = `<h4> ${title} </h4> <b> ${placeholder} </b>`
      }
    }
    if (this.$parent._isMounted) {
      this.deferredMountedTo(this.$parent.mapObject)
    }
  },
  methods: {
    deferredMountedTo(parent) {
      this.parent = parent
      this.mapObject.addTo(parent)
    }
  },
  watch: {
    item: function(newValue) {
      this.mapObject.update({
        ...newValue,
        unit: this.unit,
        title: this.title,
        placeholder: this.placeholder
      })
    }
  },
  beforeDestroy() {
    if (this.parent) {
      this.parent.removeControl(this.mapObject)
    }
  }
}
</script>
<style>
.custominfo {
  padding: 6px 8px;
  font: 18px/20px sans-serif;
  background: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.8);
  background-color: rgb(255, 255, 255) !important;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.custominfo h4 {
  margin: 0 0 5px;
  color: #777;
}
</style>